// apps/vrw-cp - ミッション詳細ページ
import React from "react";
import { GetServerSideProps } from "next";

import { MissionPage } from "@vrw-guppy/react-vrw";
import OgpHead from "@/components/OgpHead";
import { MissionReadResponse } from "@/lib/models/mission";
import { getItem } from "@/lib/apiClient";

type GetItemProps = {
  item: MissionReadResponse;
  pk: string;
};

/**
 * ミッション詳細データをSSRで取得する（高速化のためISRからSSRに変更）
 */
export const getServerSideProps: GetServerSideProps<GetItemProps> = async (context) => {
  const { type, pk } = context.params as { pk: string; type: string };
  
  // 詳細ページのSSR応答を短期キャッシュ（一覧ページと整合性を保つ）
  context.res.setHeader(
    "Cache-Control",
    "public, max-age=30, s-maxage=30"
  );
  
  try {
    const item = await getItem({
      type: type as string,
      pk: pk as string,
    });

    return {
      props: {
        item,
        pk,
      },
    };
  } catch (e: any) {
    if (String(e).includes("404")) {
      // 404エラー時はnotFoundを返す
      return {
        notFound: true,
      };
    }
    // その他のエラーはthrow
    throw e;
  }
};

const App = ({ item }: GetItemProps) => {
  return (
    <>
      <OgpHead
        title={"ミッション情報 : " + item.name}
        thumbnailUrl={item.image_url}
      />
      <MissionPage item={item} />
    </>
  );
};

export default App;
